module.exports = __webpack_public_path__ + "8085a487623e1f64f57e8b13c1db0ff6.png";